import { IVAV } from '@/Core.Service.Domain/Controls/Controls.Common/types/index.ts';

import API from '@/Core.Service.Domain/Controls/VAVs/API/index.ts';
interface IContext {
  commit: (mutation: string, payload: IVAV) => void;
}

const setVAVEdit = async (context: IContext, vav: IVAV) => {
  const response = await API.getVAVById(vav.deviceId);
  context.commit('SET_VAV_EDIT', response);
};

export default {
  setVAVEdit,
};
